export default {
  computed: {
    currentProjectIdForJobsSocket() {
      return sessionStorage.getItem('project_id');
    },
  },
  watch: {
    currentProjectIdForJobsSocket() {
      this.ensureProjectLiveJobsSubscription();
    },
  },
  methods: {
    ensureProjectLiveJobsSubscription() {
      return this.$store.dispatch('project_live_jobs/ensure_subscribed');
    },
  },
  mounted() {
    this.ensureProjectLiveJobsSubscription();
  },
};
